import { render, staticRenderFns } from "./Seminar.vue?vue&type=template&id=5333b45a&scoped=true&lang=pug&"
import script from "./Seminar.vue?vue&type=script&lang=ts&"
export * from "./Seminar.vue?vue&type=script&lang=ts&"
import style0 from "./Seminar.vue?vue&type=style&index=0&id=5333b45a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5333b45a",
  null
  
)

export default component.exports